module.exports = __webpack_public_path__ + "img/sec_03.86b3eeb7.jpg";